import { useSelector } from 'react-redux';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import useMarketsOverview from '../hooks/useMarketsOverview';
import { useMarketPicker } from '../contexts/MarketPickerContext';
import { selectSelectedResource } from '../slices/preferencesSlice';

// Phone Dashboard: work waiting in markets other than the selected one (the
// desktop hero shows this in the markets rail). Renders as its own grid item
// (pass className, for example "col-span-12") so a null render leaves no gap.
export default function AlsoDueRow({ className = '' }) {
  const overview = useMarketsOverview();
  const selected = useSelector(selectSelectedResource);
  const { setOpen } = useMarketPicker();
  if (!overview || overview.closed) return null;
  const others = (overview.rows || []).filter((r) => r.id !== selected?.id && r.total > r.ready);
  if (!others.length) return null;
  const due = others.reduce((acc, r) => acc + (r.total - r.ready), 0);
  const where = others.length === 1 ? `in ${others[0].name}` : `in ${others.length} other markets`;
  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      className={`lg:hidden flex h-12 w-full items-center gap-2.5 rounded-xl border border-gray-200/70 bg-surface px-3.5 text-left text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-600/70 dark:bg-gray-870 ${className}`}
    >
      <span className="h-2 w-2 flex-none rounded-full bg-amber-500" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        Also due: <span className="font-semibold text-gray-900 dark:text-gray-100">{due} forecast{due === 1 ? '' : 's'}</span> {where}
      </span>
      <ChevronRightIcon className="h-4 w-4 flex-none text-gray-400" aria-hidden="true" />
    </button>
  );
}
